import React from 'react';
import Styled from 'styled';

import Modal from 'four-nets/ui-v2/modal/modal';

import defaultStyles from './image-title.scss';
import ImageTitleForm from './image-title-form';
import { FormattedMessage } from 'react-intl';

interface Props {
    styles: typeof defaultStyles;
    open: boolean;
    close: () => any;
    id: string;
    title: string | null;
}

const ImageTitleDialog: React.FC<Props> = props => {
    const { open, id, title, close } = props;

    return (
        <Modal title={<FormattedMessage id='EDIT_IMAGE_TITLE' />} open={open} onClose={close}>
            <ImageTitleForm id={id} title={title} close={close} />
        </Modal>
    );
};

export default Styled(defaultStyles)(ImageTitleDialog);
